/* eslint-disable */
import { AppBar, Box, Dialog, IconButton, Toolbar, Typography, Slide, Button, Grid, DialogTitle, FormControlLabel, Checkbox, TextField, InputBase } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as BigArrowIcon } from "../../Assets/svg/bigArrowIcon.svg";
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { ReactComponent as PhoneIcon } from "../../Assets/svg/PhoneIcon.svg";
import { ReactComponent as GreenArrow } from "../../Assets/svg/greenArrow.svg";
import { ReactComponent as BooksIcon } from "../../Assets/svg/BooksIcon.svg";
import ButtonNavigation from '../../Components/ButtonNavigation';
import { ReactComponent as ThreeDotsIcon } from "../../Assets/svg/ThreeDotsIcon.svg";
import { ReactComponent as WhiteLocationIcon } from "../../Assets/svg/WhiteLocationIcon.svg";
import { ReactComponent as PersonCircleIcon } from "../../Assets/svg/PersonCircleIcon.svg";
import { ReactComponent as GrayLocation } from "../../Assets/svg/GrayLocation.svg";
import { ReactComponent as GreenCheckIcon } from "../../Assets/svg/GreenCheckIcon.svg";
import { ReactComponent as FloorIcon } from "../../Assets/svg/FloorIcon.svg";
import { ReactComponent as MobileIcon } from "../../Assets/svg/MobileIcon.svg";
import { ReactComponent as MailIcon } from "../../Assets/svg/MailIcon.svg";
import { ReactComponent as FloorNumIcon } from "../../Assets/svg/FloorNumIcon.svg";
import { ReactComponent as RoomIcon } from "../../Assets/svg/RoomIcon.svg";
import { ReactComponent as ZirbanaIcon } from "../../Assets/svg/ZirbanaIcon.svg";
import { ReactComponent as UsageTypeIcon } from "../../Assets/svg/UsageTypeIcon.svg";
import { ReactComponent as MasahatIcon } from "../../Assets/svg/MasahatIcon.svg";
import { ReactComponent as GreenDotIcon } from "../../Assets/svg/GreenDotIcon.svg";
import { ReactComponent as CloseIcon } from "../../Assets/svg/CloseIcon.svg";
import { ReactComponent as ArrowRightIcon } from "../../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as PlusIcon } from "../../Assets/svg/PlusIcon.svg";
import { ReactComponent as CalendarIcon } from "../../Assets/svg/CalendarIcon.svg";
import { ReactComponent as LabelsIcon } from "../../Assets/svg/LabelsIcon.svg";
import { ReactComponent as HouseIcon } from "../../Assets/svg/HouseIcon.svg";
import { ReactComponent as ShareIcon } from "../../Assets/svg/ShareIcon.svg";
import { ReactComponent as SendIcon } from "../../Assets/svg/SendIcon.svg";
import { ReactComponent as PenIcon } from "../../Assets/svg/PenIcon.svg";
import { ReactComponent as BackUpIcon } from "../../Assets/svg/BackUpIcon.svg";
import { ReactComponent as DelIcon } from "../../Assets/svg/DelIcon.svg";
import { ReactComponent as RoundArrowsIcon } from "../../Assets/svg/RoundArrowsIcon.svg";
import { ReactComponent as SettingDarkGray } from "../../Assets/svg/SettingDarkGray.svg";
import { ReactComponent as PlusGreenIcon } from "../../Assets/svg/PlusGreenIcon.svg";
import { ReactComponent as CheckIcon } from "../../Assets/svg/CheckIcon.svg";
import Snackbar from '@mui/material/Snackbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useParams } from "react-router-dom";
// Import Swiper styles
import 'swiper/css';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import http from '../../api/axiosInstance';
import moment from "moment-jalaali"
import { useUserStore } from '../../store/user';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
import { useSnackbar } from 'notistack';
import { TileLayer, Marker, Popup, MapContainer } from 'react-leaflet'
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import { useSearchPropStore } from '../../store/searchProperty';
import PropertyContactModal from "../../Components/PropertyContactModal";
import { CheckPermissions } from "../../Components/CheckPermissions";
import ModalComponent from "../../Components/ModalComponent";
import { newShade, lightOrDark, getUserToken, getToken } from "../../Components/PublicFunctions";
 
import { config } from '../../Components/persian-mobile-datepicker-config'
import Cookies from 'js-cookie'
 

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


function LabelItem(props) {

    // const navigate = useNavigate();
    // const goBack = () => {
    //     navigate(-1);
    // }

    const { enqueueSnackbar } = useSnackbar();

    const { labelInfo,handleGetLabels } = props

    const accessToken = useUserStore((state) => state.accessToken)
    const userInfo = useUserStore((state) => state.userInfo)
    const setUserInfo = useUserStore((state) => state.setUserInfo)

    const propFacilities = useUserStore((state) => state.propFacilities)
    const locationId = useUserStore((state) => state.locationId)
 

    const [LabelDeleteModal, setLabelDeleteModal] = useState(false)
    const [LabelDeleteLoading, setLabelDeleteLoading] = useState(false)
    const [labelDeleteId, setLabelDeleteId] = useState("")

 
 

    const dataFetchedRef = useRef(false);

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

    }, [])



    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }
 



    const handleLabelDeleteModalClick = (id) => {
        setLabelDeleteId(id)
        setLabelDeleteModal(true);
    };
    const handleLabelDeleteModalClose = () => {
        setLabelDeleteModal(false);
    };

   

    const handleDeleteLabel = async () => {
        setLabelDeleteLoading(true)
        try {
            const response = await http({
                url: `/webapp/entities/labels/delete`,
                method: "POST",
                data: {
                    "LabelId": parseInt(labelDeleteId),
                    "EntityType": 1,
                    "EntityId": labelInfo?.EntityId
                },
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            })

            if (response.data.result) {
                console.log("🚀 ~ handleDeleteLabel ~ response:", response)
                const variant = 'success'
                enqueueSnackbar("نشان گذاری با موفقیت حذف شد.", { variant });
                handleGetLabels()
            }

        } catch (e) {
            console.error(e);
            if (e.result.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }


        }

        handleLabelDeleteModalClose()
        setLabelDeleteLoading(false)
    }


    return (
        <>
            <Box className="gray-box" sx={{ borderRadius: '10px', mt: 2, p: 2, display: 'flex', flexDirection: "column", gap: "5px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Box>تاریخ ثبت : </Box>
                        <Box>{moment(labelInfo?.CreatedAt).format("jYYYY/jMM/jDD")}</Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <IconButton onClick={() => props.handleLabelsModalClick()}>
                            <img src='/assets/img/EditIcon.png' />
                        </IconButton>
                        <IconButton onClick={() => handleLabelDeleteModalClick(labelInfo.LabelId)}>
                            <img src='/assets/img/DeleteIcon.png' />
                        </IconButton>
                    </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <Box sx={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: labelInfo?.ColorCode }}></Box>
                        {labelInfo?.Text}
                    </Box>
                    <Box>
                        {moment(labelInfo?.CreatedAt).format("jYYYY/jMM/jDD")}
                    </Box>
                    <Box>
                        {labelInfo?.AssignedUserFullName ? `توسط ${labelInfo?.AssignedUserFullName}` : ""}
                    </Box>
                    <Box>
                        {`از تاریخ ${formatJalali(labelInfo?.RemindDate)} به مدت ${labelInfo?.RepeatDays} روز مهلت دارد.`}
                    </Box>
                </Box>
            </Box>



            {LabelDeleteModal && <Dialog className="dialog-box"
                open={LabelDeleteModal}
                onClose={handleLabelDeleteModalClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        آیا میخواهید این نشان گذاری را حذف کنید؟
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLabelDeleteModalClose}>خیر</Button>
                    <Button onClick={handleDeleteLabel} autoFocus>
                        {!LabelDeleteLoading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                    </Button>
                </DialogActions>
            </Dialog>}

           
        </>
    );
}

export default LabelItem;